"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  settings: {
    mimeType: 'application/ld+json',
    corsEnabled: false
  },
  environments: {
    staging: 'https://search.staging-api.immediate.co.uk',
    preproduction: 'https://search.preproduction-api.immediate.co.uk',
    production: 'https://search.api.immediate.co.uk'
  },
  endpoints: {
    search: {
      endpoint: '/v4/search'
    },
    searchv5: {
      endpoint: '/v5/search',
      appendClientToEndpoint: true,
      appendLanguage: true
    }
  }
};
exports["default"] = _default;